import GET_SERIAL_NUMBER_BY_CODE from "./getSerialNumberByCode.graphql";

const serialNumberProvider = ({ gqlClient }) => serialNumber =>
	serialNumber
		? gqlClient(GET_SERIAL_NUMBER_BY_CODE, { serialNumber }).then(
				result => result.getSerialNumberByCode,
		  )
		: Promise.resolve(null);

export default serialNumberProvider;
